export default {
  props: {
    redirectUrl: String,
    botName: String
  },
  data () {
    return {
      isLoaded: false,
      isErrorLoaded: false
    }
  },
  mounted () {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://telegram.org/js/telegram-widget.js?3'
    script.setAttribute('data-size', 'large')
    script.setAttribute('data-userpic', false)
    script.setAttribute('data-telegram-login', this.botName)
    script.setAttribute('data-radius', 0)
    script.setAttribute('data-auth-url', this.redirectUrl)
    script.onload = () => {
      this.isLoaded = true
    }
    script.onerror = () => {
      this.isErrorLoaded = true
    }
    this.$refs.telegram.appendChild(script)
  }
}
